import script from "./LoaderAtom.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderAtom.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderAtom.vue?vue&type=style&index=0&id=dd887cd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd887cd8"]])

export default __exports__